// Copyright (c) 2019 Deere & Company

import './header.scss';
import PropTypes from 'prop-types';
import React from 'react';

const AccordionHeader = props => (
    <div className="accordion-header">
        <div
            className="primary-content"
            onClick={props.onClick}
        >
            <div className="accordion-controls">
                { props.isExpanded && <i className="fa fa-chevron-down" />}
                { !props.isExpanded && <i className="fa fa-chevron-right" />}
            </div>
            <div className="accordion-header-main-section">
                <div className="accordion-header-title-section">
                    <span className="accordion-title">{props.title}</span>
                    {props.subTitle}
                </div>
                <div className="accordion-header-secondary-text">{props.secondaryText}</div>
            </div>
        </div>

    </div>
);

AccordionHeader.displayName = 'AccordionHeader';
AccordionHeader.propTypes = {
    isExpanded: PropTypes.bool.isRequired,
    onClick: PropTypes.func.isRequired,
    title: PropTypes.node.isRequired,
    subTitle: PropTypes.node,
    secondaryText: PropTypes.string,
};

export default AccordionHeader;
